import React from "react";

import async from "./components/Async";

// All pages that rely on 3rd party components (other than MUI) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
import AuthLayout from "./layouts/Auth";
import DashboardLayout from "./layouts/Dashboard";
//import OnboardLayout from "./layouts/Onboard";
//import PresentationLayout from "./layouts/Presentation";

// Guards
import AuthGuard from "./components/guards/AuthGuard";
import { RouteGuard } from "./components/guards/RouteGuard";

// Auth components
import SignIn from "./pages/auth/SignIn";
import SignUp from "./pages/auth/SignUp";
import ResetPassword from "./pages/auth/ResetPassword";
import Page404 from "./pages/auth/Page404";
import Page500 from "./pages/auth/Page500";

// Protected routes
//import ProtectedPage from "./pages/protected/ProtectedPage";
import Users from "./pages/pages/Users";
import Roads from "./pages/pages/Roads";
import Properties from "./pages/pages/properties/Properties";
import PropertyFormPage from "./pages/pages/properties/PropertyFormPage";
import Map from "./pages/pages/Map";
//import Onboarding from "./components/auth/RoadRegister";
import Ledger from "./pages/pages/accounting/Ledger";
import Journal from "./pages/pages/accounting/Journal";
import FinancialStatement from "./pages/pages/accounting/FinancialStatement";
import Docs from "./pages/pages/docs/Docs";
import FiscalYear from "./pages/pages/accounting/FiscalYear";
import Voucher from "./pages/pages/accounting/Voucher";
import Units from "./pages/pages/unitization/Units";
import Contact from "./pages/pages/Contact";
import Activate from "./pages/auth/Activate";
import Files from "./pages/pages/Files";
// import Invites from "./pages/pages/meeting/Invites";
import Presentation from "./layouts/Presentation";
// import FAQ from "./pages/presentation/Landing/FAQ";
import Terms from "./pages/presentation/Landing/Terms";
import Conversation from "./pages/pages/Conversation";
import Invoice from "./pages/pages/accounting/invoice/Invoice";
import Associations from "./pages/pages/Association";
import Coa from "./pages/pages/accounting/Coa";
import SettingsPage from "./pages/pages/Settings";
import Meetings from "./pages/pages/meeting/Meetings";
import AssociationInvoice from "./pages/pages/AssociationInvoice";
import PasswordChange from "./components/auth/PasswordChange";
// import MeetingInvite from "./pages/pages/meeting/MeetingInvite";

// Dashboard components
const Default = async(() => import("./pages/dashboards/Default"));

const routes = [
  {
    path: "/",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Default />,
      },
    ],
  },
  {
    path: "associations",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: (
          <RouteGuard resource="association" action="read">
            <Associations />
          </RouteGuard>
        ),
      },
      {
        path: "invoices/:associationId",
        element: (
          <RouteGuard resource="invoice" action="read">
            <AssociationInvoice />
          </RouteGuard>
        ),
      },
    ],
  },
  {
    path: "users",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: (
          <RouteGuard resource="user" action="read">
            <Users />
          </RouteGuard>
        ),
      },
      {
        path: "settings/:id",
        element: <SettingsPage />,
      },
    ],
  },
  {
    path: "roads",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: (
          <RouteGuard resource="road" action="read">
            <Roads />
          </RouteGuard>
        ),
      },
    ],
  },
  {
    path: "properties",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: (
          <RouteGuard resource="property" action="read">
            <Properties />
          </RouteGuard>
        ),
      },
      {
        path: "new",
        element: (
          <RouteGuard resource="property" action="create">
            <PropertyFormPage />
          </RouteGuard>
        ),
      },
      {
        path: ":id",
        element: (
          <RouteGuard resource="property" action="read">
            <PropertyFormPage />
          </RouteGuard>
        ),
      },
    ],
  },
  {
    path: "accounting",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "coa",
        element: (
          <RouteGuard resource="account" action="read">
            <Coa />
          </RouteGuard>
        ),
      },
      {
        path: "fiscal-years",
        element: (
          <RouteGuard resource="account" action="read">
            <FiscalYear />
          </RouteGuard>
        ),
      },
      {
        path: "ledger",
        element: (
          <RouteGuard resource="account" action="read">
            <Ledger />
          </RouteGuard>
        ),
      },
      {
        path: "journal",
        element: (
          <RouteGuard resource="account" action="read">
            <Journal />
          </RouteGuard>
        ),
      },
      {
        path: "financial-statement",
        element: (
          <RouteGuard resource="account" action="read">
            <FinancialStatement />
          </RouteGuard>
        ),
      },
      {
        path: "vouchers",
        element: (
          <RouteGuard resource="voucher" action="read">
            <Voucher />
          </RouteGuard>
        ),
      },
      {
        path: "invoices",
        element: (
          <RouteGuard resource="invoice" action="read">
            <Invoice />
          </RouteGuard>
        ),
      },
      {
        path: "units",
        element: (
          <RouteGuard resource="unit" action="read">
            <Units />
          </RouteGuard>
        ),
      },
    ],
  },
  // {
  //   path: "units",
  //   element: (
  //     <AuthGuard>
  //       <DashboardLayout />
  //     </AuthGuard>
  //   ),
  //   children: [
  //     {
  //       path: "list",
  //       element: (
  //         <RouteGuard resource="unit" action="read">
  //           <Units />
  //         </RouteGuard>
  //       ),
  //     },
  //   ],
  // },
  {
    path: "messages",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Conversation />,
      },
    ],
  },
  {
    path: "meetings",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: (
          <RouteGuard resource="meeting" action="read">
            <Meetings />
          </RouteGuard>
        ),
      },
      // {
      //   path: "meeting-invites/:meetingId",
      //   element: <MeetingInvite />,
      // },
    ],
  },
  {
    path: "files",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: (
          <RouteGuard resource="file" action="read">
            <Files />
          </RouteGuard>
        ),
      },
    ],
  },
  {
    path: "map",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Map />,
      },
    ],
  },
  {
    path: "website",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: (
          <RouteGuard resource="file" action="read">
            <Files />
          </RouteGuard>
        ),
      },
    ],
  },
  {
    path: "docs",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Docs />,
      },
    ],
  },
  {
    path: "contact",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Contact />,
      },
    ],
  },
  {
    path: "",
    element: <AuthLayout />,
    children: [
      {
        path: "login",
        element: <SignIn />,
      },
    ],
  },
  {
    path: "",
    element: <AuthLayout />,
    children: [
      {
        path: "register",
        element: <SignUp />,
      },
    ],
  },
  {
    path: "",
    element: <AuthLayout />,
    children: [
      {
        path: "/password-changed",
        element: <PasswordChange />,
      },
    ],
  },
  {
    path: "",
    element: <AuthLayout />,
    children: [
      {
        path: "activate",
        element: <Activate />,
      },
    ],
  },
  // {
  //   path: "",
  //   element: (
  //     <AuthGuard>
  //       <OnboardLayout />
  //     </AuthGuard>
  //   ),
  //   children: [
  //     {
  //       path: "onboarding",
  //       element: <Onboarding />,
  //     },
  //   ],
  // },
  {
    path: "",
    element: <Presentation />,
    children: [
      {
        path: "terms",
        element: <Terms />,
      },
    ],
  },
  {
    path: "",
    element: <AuthLayout />,
    children: [
      {
        path: "reset-password",
        element: <ResetPassword />,
      },
      {
        path: "404",
        element: <Page404 />,
      },
      {
        path: "500",
        element: <Page500 />,
      },
    ],
  },

  {
    path: "*",
    element: <AuthLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
